export var TargetedOffer;
(function (TargetedOffer) {
    TargetedOffer.TypeEnum = {
        Unknown: 'Unknown',
        AmountOff: 'AmountOff',
        Multibuy: 'Multibuy',
        PercentageOff: 'PercentageOff',
        BonusProduct: 'BonusProduct',
        OnecardPoints: 'OnecardPoints',
        FuelCentsOff: 'FuelCentsOff',
        FixedAmount: 'FixedAmount',
        BasketAmountOff: 'BasketAmountOff',
        BasketOnecardPoints: 'BasketOnecardPoints',
        BasketFuelCentsOff: 'BasketFuelCentsOff',
        BasketMultiplier: 'BasketMultiplier',
        BasketTiered: 'BasketTiered',
        LocalAreaBasketAmountOff: 'LocalAreaBasketAmountOff',
        LocalAreaBasketOnecardPoints: 'LocalAreaBasketOnecardPoints',
        LocalAreaBasketFuelCentsOff: 'LocalAreaBasketFuelCentsOff',
        LocalAreaBasketMultiplier: 'LocalAreaBasketMultiplier',
        LocalAreaBasketTiered: 'LocalAreaBasketTiered',
        CategoryFood: 'CategoryFood',
        CategoryFuel: 'CategoryFuel'
    };
})(TargetedOffer || (TargetedOffer = {}));
